(ns ui.view.card.view
  (:require
   [ui.view.card.activities.view :as activities-card]
   [ui.view.card.property-list.view :as property-list-card]
   [ui.view.card.attachments.view :as attachments-card]
   [ui.view.card.fees.view :as fees-card]
   [ui.view.card.risks.view :as risks-card]
   [ui.view.card.associated-entities.view :as associated-entities-card]
   [ui.view.card.decisions.view :as decisions-card]
   [ui.view.card.tasks.view :as tasks-card]
   [ui.view.card.counterparty-diligence-responder.view :as counterparty-diligence-responder-card]
   [ui.view.card.counterparty-diligence-progress.view :as counterparty-diligence-progress-card]
   [ui.view.card.counterparty-diligence-docs.view :as counterparty-diligence-docs-card]
   [ui.view.card.counterparty-diligence-screening.view :as counterparty-diligence-screening-card]
   [ui.view.card.counterparty-diligence-answers.view :as counterparty-diligence-answers-card]
   [ui.view.card.survey-processes.view :as survey-processes-card]
   [ui.view.card.sub :as sub]
   [ui.view.card.event :as event]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [oops.core :as oops]
   [ui.view.card.value-creations.view :as value-creation]))

(defn component
  [{:keys [card ctx] :as props}]
  (let [card-type (:card/type card)
        full-screen? @(rf/subscribe [::sub/full-screen? ctx])
        props (assoc props
                     :ctx ctx
                     :full-screen? full-screen?)]
    [:<>
     (case card-type
       :card.type/property-list [property-list-card/view props]
       :card.type/associations [associated-entities-card/view props]
       :card.type/activities [activities-card/view props]
       :card.type/attachments [attachments-card/view props]
       :card.type/fees [fees-card/view props]
       :card.type/risks [risks-card/view props]
       :card.type/tasks [tasks-card/view props]
       :card.type/decisions [decisions-card/view props]
       :card.type/value-creations [value-creation/view props]
       :card.type/survey-processes
       [survey-processes-card/view props]
       :card.type/counterparty-diligence-responder
       [counterparty-diligence-responder-card/view props]
       :card.type/counterparty-diligence-progress
       [counterparty-diligence-progress-card/view props]
       :card.type/counterparty-diligence-docs
       [counterparty-diligence-docs-card/view props]
       :card.type/counterparty-diligence-screening
       [counterparty-diligence-screening-card/view props]
       :card.type/counterparty-diligence-answers
       [counterparty-diligence-answers-card/view props]
       (str "Card not found " (when card-type (str " for " card-type))))]))

(defn view
  [{:keys [card entity-id card-state-path] :as props}]
  (let [ctx {:card card
             :entity-id entity-id
             :card-state-path card-state-path}
        props (assoc props :ctx ctx)]
    [component props]))

(defn view-with-data-fetching
  [{:keys [card entity-id card-state-path
           subscribe-to-realtime-changes?
           prevent-clear-state-on-unmount?
           prevent-close-subscriptions-on-unmount?]}]
  (let [abort-controller (js/AbortController.)
        signal (oops/oget abort-controller "signal")

        ctx {:signal signal
             :card card
             :entity-id entity-id
             :card-state-path card-state-path
             :subscribe-to-realtime-changes? subscribe-to-realtime-changes?}
        cleanup-fn (fn []
                     (cond
                       (and (not prevent-clear-state-on-unmount?)
                            (not prevent-close-subscriptions-on-unmount?))
                       (rf/dispatch [::event/clear-state-and-close-subscriptions ctx])

                       (not prevent-clear-state-on-unmount?)
                       (rf/dispatch [::event/clear-state ctx])

                       (not prevent-close-subscriptions-on-unmount?)
                       (rf/dispatch [::event/close-subscriptions ctx])

                       :else nil))]
    (oops/ocall signal "addEventListener" "abort" cleanup-fn)
    (r/create-class
     {:component-did-mount (fn []
                             (let [event (event/create-fetch-card-data-event ctx)]
                               (rf/dispatch event)))
      :component-will-unmount (fn []
                                (oops/ocall abort-controller "abort"))
      :reagent-render
      (fn [{:keys [card entity-id card-state-path] :as props}]
        (let [ctx {:card card
                   :entity-id entity-id
                   :card-state-path card-state-path
                   :signal signal}
              props (assoc props :ctx ctx)]
          [component props]))})))
